export abstract class Numeric {
  static ConvertToNumber(value: any, defaultValue: number = 0) {
    if (typeof value === "undefined") {
      return defaultValue;
    }
    return Number(value) || defaultValue;
  }
}
